import api from './api';

export const listWorkshops = (factoryId) =>
  api.get(`/factories/${factoryId}/workshops`).then(r => r.data);

export const getWorkshopDetail = (workshopId) =>
  api.get(`/workshops/${workshopId}`).then(r => r.data);

export const createWorkshop = (factoryId, data) =>
  api.post(`/factories/${factoryId}/workshops`, data).then(r => r.data); 

export const updateWorkshop = (workshopId, data) =>
  api.put(`/workshops/${workshopId}`, data).then(r => r.data);

export const deleteWorkshop = (workshopId) =>
  api.delete(`/workshops/${workshopId}`).then(r => r.data);